const Search = ({setSearch}) => {

	const handleSubmit = (e) => {
		e.preventDefault();

		setSearch(e.target.elements.search.value);
	}

	return (
		<div className="index-page__search">
			<form onSubmit={handleSubmit} aria-label="search">
				<input type="search" name="search" placeholder="Search" />
				<button type="submit" aria-label="submit search">
					<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg" aria-labelledby="search-button">
						<title id="search-button">Submit Search</title>
						<path d="M8.375 0.75C10.5299 0.75 12.5965 1.60602 14.1202 3.12976C15.644 4.65349 16.5 6.72012 16.5 8.875C16.5 10.8875 15.7625 12.7375 14.55 14.1625L14.8875 14.5H15.875L22.125 20.75L20.25 22.625L14 16.375V15.3875L13.6625 15.05C12.1882 16.3085 10.3134 16.9999 8.375 17C6.22012 17 4.15349 16.144 2.62976 14.6202C1.10602 13.0965 0.25 11.0299 0.25 8.875C0.25 6.72012 1.10602 4.65349 2.62976 3.12976C4.15349 1.60602 6.22012 0.75 8.375 0.75ZM8.375 3.25C5.25 3.25 2.75 5.75 2.75 8.875C2.75 12 5.25 14.5 8.375 14.5C11.5 14.5 14 12 14 8.875C14 5.75 11.5 3.25 8.375 3.25Z" fill="#000"/>
					</svg>
				</button>
			</form>
		</div>
	)
}

export default Search;
